import app from 'flarum/forum/app';

app.initializers.add('mattoid/flarum-ext-store-auto-check-in', () => {
  console.log('[mattoid/flarum-ext-store-auto-check-in] Hello, forum!');
});
